import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeliveryNoteActionsDialogContentComponent } from './delivery-note-actions-dialog-content/delivery-note-actions-dialog-content.component';

@Component({
  selector: 'app-delivery-note-actions-dialog',
  template: ''
})
export class DeliveryNoteActionsDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    var deliveryNoteId = this.activatedRoute.snapshot.params.key;
    var isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];

    const dialogRef = this.dialog.open(DeliveryNoteActionsDialogContentComponent, { centered: true, size: 'md', backdrop: 'static' });
    dialogRef.componentInstance.deliveryNoteId = deliveryNoteId;
    dialogRef.componentInstance.customerId = customerId;
    dialogRef.componentInstance.isOperatorView = isOperatorView;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }

}
